var map = {
	"./face1.png": 437,
	"./face2.png": 438,
	"./face3.png": 439
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 436;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/face.*\.png$
// module id = 436
// module chunks = 0